
    const original = "<svg width=\"310\" height=\"310\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" overflow=\"hidden\"><g transform=\"translate(-2265 -1439)\"><rect x=\"2391\" y=\"1572\" width=\"146\" height=\"146\" fill=\"#855CD6\" fill-opacity=\"0.4\"/><path d=\"M2396 1467C2445.71 1467 2486 1507.43 2486 1557.3L2485.78 1559.48 2380.14 1559.48 2380.14 1646 2377.86 1645.77C2336.85 1637.35 2306 1600.94 2306 1557.3 2306 1507.43 2346.29 1467 2396 1467Z\" fill=\"#855CD6\" fill-rule=\"evenodd\"/></g></svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original
                .replace(/#855cd6/gi, Recolor.primary)
                .replace(/#A384E0/gi, Recolor.primaryLight || Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
